import { Component, Input } from '@angular/core';
import { ExternalCrewInfo } from 'src/app/models/ExternalCrewInfo';

@Component({
    selector: 'app-crew-details',
    templateUrl: './crew-details.component.html',
    styleUrls: ['./crew-details.component.scss'],
    standalone: false
})
export class CrewDetailsComponent {

  @Input() crew: ExternalCrewInfo;
}
